import {
  getSignOnPolicy as publicGetSignOnPolicy,
  updateSignOnPolicy as publicUpdateSignOnPolicy,
} from './iam-signon-v1-sign-on-policy-sign-on-policy.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onSignOnPolicyUpdated as publicOnSignOnPolicyUpdated } from './iam-signon-v1-sign-on-policy-sign-on-policy.public.js';

export const getSignOnPolicy: MaybeContext<
  BuildRESTFunction<typeof publicGetSignOnPolicy> & typeof publicGetSignOnPolicy
> = /*#__PURE__*/ createRESTModule(publicGetSignOnPolicy);
export const updateSignOnPolicy: MaybeContext<
  BuildRESTFunction<typeof publicUpdateSignOnPolicy> &
    typeof publicUpdateSignOnPolicy
> = /*#__PURE__*/ createRESTModule(publicUpdateSignOnPolicy);
/** */
export const onSignOnPolicyUpdated: BuildEventDefinition<
  typeof publicOnSignOnPolicyUpdated
> &
  typeof publicOnSignOnPolicyUpdated = /*#__PURE__*/ createEventModule(
  publicOnSignOnPolicyUpdated
);

export {
  State,
  SiteCreatedContext,
  Namespace,
  DeleteStatus,
  WebhookIdentityType,
} from './iam-signon-v1-sign-on-policy-sign-on-policy.universal.js';
export {
  SignOnPolicy,
  MetaSiteSpecialEvent,
  MetaSiteSpecialEventPayloadOneOf,
  Asset,
  SiteCreated,
  SiteTransferred,
  SiteDeleted,
  DeleteContext,
  SiteUndeleted,
  SitePublished,
  SiteUnpublished,
  SiteMarkedAsTemplate,
  SiteMarkedAsWixSite,
  ServiceProvisioned,
  ServiceRemoved,
  SiteRenamed,
  SiteHardDeleted,
  NamespaceChanged,
  StudioAssigned,
  StudioUnassigned,
  SiteUrlChanged,
  SitePurgedExternally,
  OdeditorAssigned,
  OdeditorUnassigned,
  PicassoAssigned,
  PicassoUnassigned,
  WixelAssigned,
  WixelUnassigned,
  StudioTwoAssigned,
  StudioTwoUnassigned,
  UserDomainMediaEnabled,
  UserDomainMediaDisabled,
  EditorlessAssigned,
  EditorlessUnassigned,
  Empty,
  GetSignOnPolicyRequest,
  GetSignOnPolicyResponse,
  UpdateSignOnPolicyRequest,
  UpdateSignOnPolicyResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  SignOnPolicyUpdatedEnvelope,
} from './iam-signon-v1-sign-on-policy-sign-on-policy.universal.js';
export {
  StateWithLiterals,
  SiteCreatedContextWithLiterals,
  NamespaceWithLiterals,
  DeleteStatusWithLiterals,
  WebhookIdentityTypeWithLiterals,
  GetSignOnPolicyApplicationErrors,
  UpdateSignOnPolicyApplicationErrors,
} from './iam-signon-v1-sign-on-policy-sign-on-policy.universal.js';
